export const SET_SHARE_CONTEXT = 'THANK_YOU/SET_SHARE_CONTEXT';
export const CLEAR_SHARE_CONTEXT = 'THANK_YOU/CLEAR_SHARE_CONTEXT';

export const setShareContext = (payload) => ({
  type: SET_SHARE_CONTEXT,
  payload,
});

export const clearShareContext = () => ({
  type: CLEAR_SHARE_CONTEXT,
});
